import React, { useState } from 'react';
import Navegation from '../../components/common/navegationHome/Navegation';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MyStands from '../../components/myStands/MyStands';
import Hall from '../../components/hall/Hall';
import Sells from '../../components/sells/Sells';
import Stand from '../../components/stands/Stand';
import ViewStand from '../../components/stands/viewStand/ViewStand';
import ViewCombos from '../../components/combos/viewCombos/ViewCombos';
import NewCombo from '../../components/combos/newCombo/NewCombo';
import CombosTable from '../../components/hall/combosTable/CombosTable';

const Provider = () => {
  const { path } = useRouteMatch();
  const [productsForComboEdit, setProductsForComboEdit] = useState([]);

  return (
    <>
      <Navegation/>
      <Switch>
        <Route path={`${path}/hall`} component={Hall}/>
        <Route path={`${path}/stand/view/:id`} component={ViewStand}/>
        <Route path={`${path}/stand/:id`} component={Stand}/>
        <Route path={`${path}/mis-combos/new-combo`} >
          <NewCombo productsForComboEdit={productsForComboEdit}/>
        </Route>
        <Route path={`${path}/mis-combos`}>
          <ViewCombos setProductsForComboEdit={setProductsForComboEdit}/>
        </Route>
        <Route path={`${path}/mis-ventas`} component={Sells}/>
        <Route path={`${path}/sell/:id`} component={CombosTable}/>
        <Route path={`${path}/`} component={MyStands}/>
      </Switch> 
    </>
  );
};

export default Provider;